'use client'

import { useEffect } from 'react'

/** Sets <html lang>. See the note in app/en/layout.js for why this is not done server-side. */
export default function HtmlLang({ lang }) {
  useEffect(() => {
    const prev = document.documentElement.lang
    document.documentElement.lang = lang
    return () => {
      document.documentElement.lang = prev
    }
  }, [lang])
  return null
}
